import Vue from 'vue';
export const MapEventHub = new Vue({
    data() {
        return {
            isMobile: false,
            filteredProperties: [],
            activeProperty: null,
            hoverType: 'pin',
            idle: false,
            mappedMarkers: null
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        updateFilteredProperties(properties) {
            this.filteredProperties = properties;
            this.$emit('propertiesUpdated');
        },
        resetFilteredProperties() {
            this.filteredProperties = [];
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 1200;
        },
    },
});